<template>
  <div class="row">
    <div class="col-20 std-wrapper main-wrapper">
      <div class="row p-4">
        <div class="col-20 font-weight-bold">
          <span v-if="userArchetype">
            {{ $t('view-Archetypes.selected-archetype') }}
            <span class="text-danger ml-2">{{ userArchetype.name }}</span>
          </span>
          <span v-else>
            {{ $t('view-Archetypes.choose-archetype') }}
          </span>
        </div>
        <div class="col-20 text-center">
          <archetype-circle
            :value="userArchetype ? userArchetype.id : null"
            @input="setArchetype"
          />
        </div>
        <div
          v-if="aiArchetypes"
          class="col-20 font-weight-bold mt-4"
        >
          {{ $t('view-Archetypes.archetypes-selected-by-ai') }}
          <span
            v-for="(item, index) in aiArchetypes"
            :key="item.id"
          >
            <span class="text-primary ml-2">{{ item.name }} {{ item.probability }}%</span>
            <span v-if="index+1 < aiArchetypes.length">, </span>
          </span>
        </div>
        <div
          v-if="aiArchetypes"
          class="col-20"
        >
          <div class="ai-info">
            <strong>{{ $t('view-Archetypes.archetypes-ai-into.title') }}</strong><br>
            {{ $t('view-Archetypes.archetypes-ai-into.text') }}<br>
            {{ $t('view-Archetypes.archetypes-ai-into.languege-requirments') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import archetypesCircle from '../../components/ArchetypesCircle'

export default {
  components: {
    'archetype-circle': archetypesCircle
  },
  data () {
    return {

    }
  },
  computed: {
    userArchetype () {
      const archetypes = this.$store.state.user.profileTypeData.userArchetypes
      return archetypes.length > 0 ? this.$store.getters['archetypes/getByTag'](archetypes[0].archetypeData.tag) : null
    },
    aiArchetypes () {
      const archetypes = this.$store.state.user.profileTypeData.aiArchetypes
      if (archetypes.length > 0) {
        const result = []
        for (const item of archetypes) {
          result.push({
            ...this.$store.getters['archetypes/getByTag'](item.archetypeData.tag),
            probability: (item.probability * 100).toFixed(2) * 100 / 100
          })
        }
        return result
      } else {
        return null
      }
    }
  },
  created () {
    if (this.$store.state.archetypes.items.length === 0) {
      this.$store.dispatch('archetypes/get').catch(e => {})
    }
    this.$store.dispatch('user/getProfile').catch(e => {})
  },
  methods: {
    setArchetype (archetypeId) {
      this.$store.dispatch('user/setArchetype', archetypeId)
        .then(result => {
          this.$flash.success(this.$t('view-Archetypes.message.success'))
        })
        .catch(e => {
          this.$flash.error(this.$t('view-Archetypes.message.error'))
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ai-info {
    border: 2px solid $nh-gray;
    border-radius: 5px;
    font-size: 0.75rem;
    padding: 0.75rem;
    margin-top: 1rem;
  }
</style>
